import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "../css/estudiantes.css";
import {
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
  } from 'mdb-react-ui-kit';
import Loading from '../components/Loading';
import asignaturaService from "../services/asignaturaService";
import Swal from "sweetalert2";
import AsignaturaForm from "../components/Forms/FormAsignatura";
import PersonalizarAsignaturaModal from "../components/Forms/PersonalizarAsignaturaModal";
import useCustomDataTableStyles from "../components/estilosDeDataTable";
import types from "../services/types";


const Asignatura = () => {
  
    const [fullscreenXlModal, setFullscreenXlModal] = useState(false);
    const [asignaturas, setAsignaturas] = useState([]);
    const [selectedAsignatura, setSelectedAsignatura] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [BtnVer, setBtnVer] = useState('');
    const [personalizarModal, setPersonalizarModal] = useState(false);
    const [asignaturaAPersonalizar, setAsignaturaAPersonalizar] = useState(null);
    const customStyles = useCustomDataTableStyles();

    const openPersonalizarModal = (asignatura) => {
        setAsignaturaAPersonalizar(asignatura);
        setPersonalizarModal(true);
    };

    const closePersonalizarModal = () => {
        setPersonalizarModal(false);
        setAsignaturaAPersonalizar(null);
    };


    const toggleShow = () => {
        setFullscreenXlModal(!fullscreenXlModal);
        setSelectedAsignatura(null); 
    }

    const openMaximizeModal = (asignatura) => {
        setSelectedAsignatura(asignatura);
        setFullscreenXlModal(true);
        setBtnVer(true);
    };

    const openEditingModal = async (asignatura) => {
        setSelectedAsignatura(asignatura);
        setFullscreenXlModal(true);
        setBtnVer(false);
    };
    
    const openAddingModal = async (asignatura) => {
        setSelectedAsignatura(asignatura);
        setFullscreenXlModal(true);
        setBtnVer(false);
    };

    const deleteAsignatura = async(asignatura)=>{
      Swal.fire({
          title: 'Esta seguro que desea eliminar esta asignatura?',
          text: "",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, eliminar!'
        }).then(async(result) => {
          if (result.isConfirmed) {
            try{
            await asignaturaService.deleteAsignaturaById(asignatura.schoolSubjectId);
            Swal.fire(
              'Felicidades!',
              'Asignatura eliminada exitosamente!',
              'success'
            );
            fetchAsignaturas();
            }catch(error){
              Swal.fire(
                  "Ha ocurrido un error",
                  "Por favor intentelo mas tarde",
                  "error"
              );
            }
          }
        })
  }

    const fetchAsignaturas = async () => {
        try {
            const response = await asignaturaService.getAsignaturas()
            setAsignaturas(response);
        } catch (error) {
            console.error("Error al obtener las asignaturas:", error);
        }
    };

    useEffect(() => {
      fetchAsignaturas();
    }, []);
    
  const columns = [
    { name: "N°", selector: "consecutive",grow:0.05, sortable: true, 
    cell: (row, index) => <span>{index + 1}</span>, },               
    { name: "Nombre", selector: "name", sortable: true, grow:4},            
    { name: "Abrev.", selector: "abbreviation", sortable: true },   
    { name: "Area", selector: "academicAreaName",grow:3.5, sortable: true },            
    { name: "Orden", selector: "orden", sortable: true },                 
    { name: "Activo", selector: "isActive", sortable: true,
    cell: (row) => (
      <>
       {row.isActive ? <span>Si</span> : <span>No</span>}
      </>
    ), },             // Si el período académico está activo o no
    {
      name: "Acciones",grow:"2.5",
      selector: "actions",
      cell: (row) => (
        <div className="actions-container justify-content-between align-items-center">
          <button
            onClick={() => openMaximizeModal(row)}
            className="btn-maximize btn-sm me-2"
            title="Maximizar información"
          >
            <i className="fas fa-eye"></i>
          </button>
          <button
            onClick={() => openEditingModal(row)}
            className="btn-edit btn-sm me-2"
            title="Editar"
          >
            <i className="icon-edit fas fa-pencil-alt"></i>
          </button>
          {Number(row.evaluationTypeId) === types.evaluationTypes.ESCALA_VALORATIVA && (
            <button
              onClick={() => openPersonalizarModal(row)}
              className="btn-edit btn-sm me-2"
              title="Personalizar intensidad horaria, porcentaje, área o visibilidad por año, periodo o grado"
            >
              <i className="fa-solid fa-sliders"></i>
            </button>
          )}
          <button
            onClick={() => deleteAsignatura(row)}
            className="btn-deactivate btn-sm"
            title="Eliminar"
          >
            <i className="icon-deactivate fas fa-times"></i>
          </button>
        </div>
      ),
    },
  ];

  const normalizeString = (str) => {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  const filteredItems = asignaturas?.filter((item) => {
    if (item) {
      const allData = `${item.consecutive} ${item.name} ${item.order} ${item.abbreviation} ${item.isActive}`;
      const normalizedFilterText = normalizeString(filterText);
      const normalizedItemName = normalizeString(allData);
      return normalizedItemName.includes(normalizedFilterText);
    }
    return item;
  });


  const paginationPerPage = 50; // Ajusta este número según tus necesidades

  return (
    <div className="student-table-container p-3">
      <h1>Asignaturas</h1>
      <p>Esta es la vista de las asignaturas académicas.</p>

            <div className="student-table-controls mb-3 d-flex justify-content-between align-items-center">
                <input
                    type="text"
                    placeholder="Buscar"
                    value={filterText}
                    onChange={e => setFilterText(e.target.value)}
                    className="form-control form-control-sm w-50"
                />
                <div className="btn-group">
                    <button className="btn-sm btn-Estudiante btn-NuevoEstudiante"  onClick={() => openAddingModal(null)} >Nueva asignatura <i className="fa-solid fa-circle-plus"></i></button>
                </div>
            </div>
            <DataTable
                title="Lista de asignaturas"
                className="students-datatable shadow-sm rounded"
                noDataComponent="No hay información que mostrar, por favor añadela"   
                columns={columns}
                data={filteredItems}
                pagination
                fixedHeader
                customStyles={customStyles}
                paginationPerPage={paginationPerPage} // Agrega esta propiedad para controlar las filas por página
                paginationRowsPerPageOptions={[50, 100]}

            />

             {/* Renderiza el modal y el formulario aquí */}
            <>
                <MDBModal tabIndex='-1' show={fullscreenXlModal} setShow={setFullscreenXlModal}>
                <MDBModalDialog className="modal-xl-custom">
                    <MDBModalContent>
                    <MDBModalHeader>
                        <MDBModalTitle>DETALLES DE LA ASIGNATURA</MDBModalTitle>
                        <MDBBtn
                        type='button'
                        className='btn-close'
                        color='none'
                        onClick={toggleShow}
                        ></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                        <div className='card'>
                            {selectedAsignatura && (
                                <AsignaturaForm
                                    key={Date.now()}
                                    asignatura={selectedAsignatura.schoolSubjectId}
                                    onClose={() => {
                                        setFullscreenXlModal(false); 
                                        fetchAsignaturas();
                                    }}
                                    ReadOnly={BtnVer}
                                />
                            )}

                            { !selectedAsignatura && (
                                <AsignaturaForm
                                    key={Date.now()}
                                    asignatura={0}
                                    onClose={() => {
                                        setFullscreenXlModal(false); 
                                        fetchAsignaturas();
                                    }}
                                    ReadOnly={false}
                                />
                            )}
                        </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                    <button type='button' className='btn-footer-close btn-primary' onClick={toggleShow}>
                        Cerrar
                    </button>
                    </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
                </MDBModal>
            </>

            <>
                <MDBModal tabIndex='-1' show={personalizarModal} setShow={setPersonalizarModal}>
                <MDBModalDialog className="modal-xl-custom">
                    <MDBModalContent>
                    <MDBModalHeader>
                        <MDBModalTitle>PERSONALIZAR ASIGNATURA: {asignaturaAPersonalizar?.name}</MDBModalTitle>
                        <MDBBtn
                        type='button'
                        className='btn-close'
                        color='none'
                        onClick={closePersonalizarModal}
                        ></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                        {asignaturaAPersonalizar && (
                            <PersonalizarAsignaturaModal
                                key={asignaturaAPersonalizar.schoolSubjectId}
                                schoolSubjectId={asignaturaAPersonalizar.schoolSubjectId}
                                schoolSubjectName={asignaturaAPersonalizar.name}
                            />
                        )}
                    </MDBModalBody>
                    <MDBModalFooter>
                    <button type='button' className='btn-footer-close btn-primary' onClick={closePersonalizarModal}>
                        Cerrar
                    </button>
                    </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
                </MDBModal>
            </>

        </div>
    );
};

export default Asignatura;
